import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class Module extends EntityDto implements IEntityDto{
  Module_Id: string;
  Module_Name: string; 
  TotalCount: number;


  constructor() {
    super();
    this.Module_Id = "";
    this.Module_Name = ""; 
    this.TotalCount = 0;
    this.EntityMetaData = [
      {FieldName:'Module_Name',FieldType:FieldType.String,IsMandatory:true,ValidationMessage:'Name is required'}
    ];
    }
}
